module.exports = __webpack_public_path__ + "static/the-night-watchman-102dcbb6bf2d4d10419a255d42aa6ef3.jpg";